import { render, staticRenderFns } from "./TooltipAjudaLista.vue?vue&type=template&id=277b4a04&lang=html"
import script from "./TooltipAjudaLista.vue?vue&type=script&lang=js"
export * from "./TooltipAjudaLista.vue?vue&type=script&lang=js"
import style0 from "./TooltipAjudaLista.vue?vue&type=style&index=0&id=277b4a04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports